import Plans from "./index.vue";
import { BadRequestError } from "@/api/types";
import { getErrorMessages } from "@/helpers/api-helper";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      messages: []
    };
  },
  computed: {
    plans() {
      return this.$store.state.domains.plans.plans;
    },
    availableGraduateYears() {
      return this.$store.state.domains.service.availableGraduateYears;
    },
    partnerUser() {
      return this.$store.state.domains.user.partnerUser;
    },
    planId() {
      return Number(this.$route.params["planId"]);
    },
    isCreateFloatingViewVisible() {
      return this.$store.state.pages.plans.isCreateFloatingViewVisible;
    },
    isDuplicationFloatingViewVisible() {
      return this.$store.state.pages.plans.isDuplicationFloatingViewVisible;
    },
    isUpdateFloatingViewVisible() {
      return this.$store.state.pages.plans.isUpdateFloatingViewVisible;
    },
    isDeleteFloatingViewVisible() {
      return this.$store.state.pages.plans.isDeleteFloatingViewVisible;
    }
  },
  mounted() {
    this.getPlans();
    this.getAvailableGraduateYears();
  },
  methods: {
    handleClickCreateFloatingViewOpen() {
      this.$store.commit("pages/plans/updateCreateFloatingView", {
        isVisible: true
      });
    },
    handleClickCreateFloatingViewClose() {
      this.clearErrorMessage();
      this.$store.commit("pages/plans/updateCreateFloatingView", {
        isVisible: false
      });
    },
    handleClickDuplicationFloatingViewOpen() {
      this.$store.commit("pages/plans/updateDuplicationFloatingView", {
        isVisible: true
      });
    },
    handleClickDuplicationFloatingViewClose() {
      this.$store.commit("pages/plans/updateDuplicationFloatingView", {
        isVisible: false
      });
    },
    handleClickUpdateFloatingViewOpen() {
      this.$store.commit("pages/plans/updateEditFloatingView", {
        isVisible: true
      });
    },
    handleClickUpdateFloatingViewClose() {
      this.clearErrorMessage();
      this.$store.commit("pages/plans/updateEditFloatingView", {
        isVisible: false
      });
    },
    handleClickDeleteFloatingViewOpen() {
      this.$store.commit("pages/plans/updateDeleteFloatingView", {
        isVisible: true
      });
    },
    handleClickDeleteFloatingViewClose() {
      this.$store.commit("pages/plans/updateDeleteFloatingView", {
        isVisible: false
      });
    },
    async getAvailableGraduateYears() {
      try {
        if (!this.partnerUser) return;
        await this.$store.dispatch(
          "domains/service/getAvailableGraduateYears",
          {
            partner_id: this.partnerUser.partner.id
          }
        );
      } catch (error) {
        throw error;
      }
    },
    async getPlans() {
      try {
        if (!this.partnerUser) return;
        await this.$store.dispatch("domains/plans/getPlans", {
          partnerId: this.partnerUser.partner.id
        });
      } catch (error) {
        throw error;
      }
    },
    async handleCreatePlan(name, graduateYear) {
      this.clearErrorMessage();
      try {
        if (!this.partnerUser) return;
        await this.$store.dispatch("domains/plans/createPlan", {
          partnerId: this.partnerUser.partner.id,
          name: name,
          graduateYear: graduateYear
        });
        this.$store.commit("pages/plans/updateCreateFloatingView", {
          isVisible: false
        });
      } catch (error) {
        if (error instanceof BadRequestError) {
          this.messages = getErrorMessages(error);
        }
        throw error;
      }
    },
    async handleUpdatePlan(updatePlan) {
      this.clearErrorMessage();
      try {
        if (!this.partnerUser) return;
        await this.$store.dispatch("domains/plans/updatePlan", {
          partnerId: this.partnerUser.partner.id,
          planId: updatePlan.id,
          name: updatePlan.name
        });
        this.$store.commit("pages/plans/updateEditFloatingView", {
          isVisible: false
        });
      } catch (error) {
        if (error instanceof BadRequestError) {
          this.messages = getErrorMessages(error);
        }
        throw error;
      }
    },
    async handleDeletePlan(deletePlanId) {
      try {
        if (!this.partnerUser) return;
        await this.$store.dispatch("domains/plans/deletePlan", {
          partnerId: this.partnerUser.partner.id,
          planId: deletePlanId
        });
        this.$store.commit("pages/plans/updateDeleteFloatingView", {
          isVisible: false
        });
        this.$store.commit("pages/plans/updateEditFloatingView", {
          isVisible: false
        });
      } catch (error) {
        throw error;
      }
    },
    async handleClickDuplicationPlanCreate(duplicationPlan) {
      try {
        if (!this.partnerUser) return;
        await this.$store.dispatch("domains/plans/duplicatePlan", {
          partnerId: this.partnerUser.partner.id,
          planId: duplicationPlan.id,
          name: duplicationPlan.name,
          graduateYear: duplicationPlan.graduateYear
        });
        this.$store.commit("pages/plans/updateDuplicationFloatingView", {
          isVisible: false
        });
      } catch (error) {
        if (error instanceof BadRequestError) {
          this.messages = getErrorMessages(error);
        }
        throw error;
      }
    },
    clearErrorMessage() {
      this.messages = [];
    }
  },
  render(createElement) {
    return createElement(Plans, {
      props: {
        plans: this.plans,
        availableGraduateYears: this.availableGraduateYears,
        messages: this.messages,
        isCreateFloatingViewVisible: this.isCreateFloatingViewVisible,
        isDuplicationFloatingViewVisible: this.isDuplicationFloatingViewVisible,
        isUpdateFloatingViewVisible: this.isUpdateFloatingViewVisible,
        isDeleteFloatingViewVisible: this.isDeleteFloatingViewVisible
      },
      on: {
        clickCreateFloatingViewOpen: this.handleClickCreateFloatingViewOpen,
        clickCreateFloatingViewClose: this.handleClickCreateFloatingViewClose,
        clickUpdateFloatingViewOpen: this.handleClickUpdateFloatingViewOpen,
        clickUpdateFloatingViewClose: this.handleClickUpdateFloatingViewClose,
        clickDeleteFloatingViewOpen: this.handleClickDeleteFloatingViewOpen,
        clickDeleteFloatingViewClose: this.handleClickDeleteFloatingViewClose,
        clickDuplicationFloatingViewOpen: this
          .handleClickDuplicationFloatingViewOpen,
        clickDuplicationFloatingViewClose: this
          .handleClickDuplicationFloatingViewClose,
        clickDuplicationPlanCreate: this.handleClickDuplicationPlanCreate,
        createPlan: this.handleCreatePlan,
        updatePlan: this.handleUpdatePlan,
        deletePlan: this.handleDeletePlan
      }
    });
  }
});
